import LegalEntityFunctions from "components/components/LegalEntityFunctions.jsx";
import { LATVIAN_LEGAL_ENTITY_ID } from "../components/constants/legalEntityIds.js";
import { NON_DIGITS_REGEX } from "components/constants/regexConstants.jsx";

const formatLatvianPersonalCode = (value) => {
  value = value.replace(/[^0-9-]/g, '');

  const dashIndex = value.indexOf('-');
  if (dashIndex !== -1) {
    // If dash is at position 6, keep it there and remove any additional dashes
    if (dashIndex === 6) {
      const beforeDash = value.substring(0, 7);
      const afterDash = value.substring(7).replace(/-/g, '');
      value = beforeDash + afterDash;
    } else {
      // If dash is not at position 6, move it there
      const digitsOnly = value.replace(/-/g, '');
      if (digitsOnly.length >= 6) {
        value = digitsOnly.substring(0, 6) + '-' + digitsOnly.substring(6);
      } else {
        value = digitsOnly;
      }
    }
  } else if (value.length > 6) {
    // No dash present, insert automatically after 6 digits if we have more than 6
    value = value.substring(0, 6) + '-' + value.substring(6);
  }

  return value;
};

const formatStandardPersonalCode = value => {
	return value.replace(NON_DIGITS_REGEX, "");
}

const formatPersonalCodeInput = (value, legalEntityId) => {
  if (legalEntityId === LATVIAN_LEGAL_ENTITY_ID) {
    return formatLatvianPersonalCode(value);
  }

  return formatStandardPersonalCode(value);
};

export const generatePersonalCodePlaceholder = (legalEntityId) => {
  if (legalEntityId === LATVIAN_LEGAL_ENTITY_ID) {
    return "XXXXXX-XXXXX";
  } else {
    return "X".repeat(11);
  }
};

export const getPersonalCodeMaxLength = (legalEntityId) => {
  return Math.max(...LegalEntityFunctions.getPersonalCodeLengths()[legalEntityId]);
};

export const createPersonalCodeChangeHandler = (onPersonalCodeChange, legalEntityId) => {
  return (event) => {
    const formattedValue = formatPersonalCodeInput(event.value, legalEntityId);
    
    onPersonalCodeChange({
      ...event,
      value: formattedValue
    });
  };
};

export const validatePersonalCodeFormatting = (personalCode, legalEntityId) => {
  let isValid = !!personalCode;
  let errorMessage = "";
  
  if (!isValid) {
    errorMessage = "smart_id_add_wizard_personal_code_required_error";
  } else if (!LegalEntityFunctions.getPersonalCodeLengths()[legalEntityId].includes(personalCode.length)) {
    errorMessage = "smart_id_add_wizard_personal_code_length_error";
    isValid = false;
  }
  
  return { isValid, errorMessage };
}; 